module.exports = __webpack_public_path__ + "img/__icon_CIĄGNIK_SIODŁOWY.b486284b.svg";